import React from 'react';
import { SnackbarProvider } from 'notistack';
import SearchAbstractsComponent from '../../Components/searchAbstractsComponent';

const SearchAbstracts = () => {
  return (
    <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
      <div className="main-wrapper">
        {/* <AsidebarSearchResult /> */}
        <div className="content-wrapper">
          <SearchAbstractsComponent />
        </div>
      </div>
    </SnackbarProvider>
  );
}

export default SearchAbstracts;
